import { useState } from 'react'

export const useCurrentCountry = () => {
  const [currentCountry, setCurrentCountry] = useState<string | undefined>()

  if (!currentCountry) {
    fetch('https://ipinfo.io/json')
      .then((response) => response.json())
      .then((data) => {
        setCurrentCountry(data.country)
      })
      .catch((error) => console.error('Error fetching country:', error))
  }

  return currentCountry
}
